
export const DEFAULT_PAGE_SIZE = 10;

export const HACKATHON_QUERY_CONFIG = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE
} as const;

export const DOMAIN_SUFFIX = '.fans.cspr';
export const VALIDATION_ERROR_MESSAGE =
  'The subname must be 1-63 characters, lowercase. It may only contain letters (a-z), numbers (0-9), and hyphens (-). Spaces are not permitted, and it cannot start or end with a hyphen.';
export const UNAVAILABLE_MESSAGE = 'This name is unavailable';
export const CLAIM_TIMEOUT_MS = 180_000;
export const INCOMPLETE_CRITERIA_MESSAGE = 'You need to unlock your gift first';
export const SUCCESS_MESSAGE = 'This name is available';
export const HOW_VOTING_WORKS_URL = `${window.location.origin}/how-voting-works.html`;


export const PLATFORM = {
  IOS: 'ios',
  ANDROID: 'android'
} as const;

export const WALLET_URLS = {
  CASPER_WALLET: 'https://www.casperwallet.io',
  DOWNLOAD: 'https://www.casperwallet.io/download'
} as const;
export const MOTES_PER_CSPR_RATE = '1000000000'; // 1 000 000 000 MOTES === 1 CSPR
